export const REVIEW_REACTION_EMOJI_ORDER = [
  { key: 'THUMBS_UP', emoji: '👍' },
  { key: 'HEART', emoji: '❤️' },
  { key: 'LAUGH', emoji: '😂' },
  { key: 'FIRE', emoji: '🔥' },
  { key: 'NERD', emoji: '🤓' },
];

function readCount(value) {
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0
    ? value
    : 0;
}

export function readReviewReactionEngageMetrics(metrics, prefix) {
  const counts = metrics?.[`${prefix}ReviewReactionCounts`];
  const countMap = counts && typeof counts === 'object' ? counts : {};
  return {
    total: readCount(metrics?.[`${prefix}ReviewReactionTotal`]),
    reviewsWithReactions: readCount(
      metrics?.[`${prefix}ReviewsWithReactionsCount`],
    ),
    counts: {
      THUMBS_UP: readCount(countMap.THUMBS_UP),
      HEART: readCount(countMap.HEART),
      LAUGH: readCount(countMap.LAUGH),
      FIRE: readCount(countMap.FIRE),
      NERD: readCount(countMap.NERD),
    },
    fromUsers: readCount(metrics?.[`${prefix}ReviewReactionsFromUsers`]),
    fromBreweries: readCount(metrics?.[`${prefix}ReviewReactionsFromBreweries`]),
  };
}
